import script from "./FlyerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyerCard.vue?vue&type=script&setup=true&lang=js"

import "./FlyerCard.vue?vue&type=style&index=0&id=154af9f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154af9f8"]])

export default __exports__